import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';
import FeatureHighlight from '@/app/components/LegacyLandingPage/components/FeatureHighlight';

export interface FeatureHighlightsType {
  id: number;
  title: MessageKey;
  description: MessageKey;
  image: string;
  reverse?: boolean;
}

interface FeatureHighlightsProps {
  readonly features: FeatureHighlightsType[];
}

const FeatureHighlights = ({ features }: FeatureHighlightsProps) => {
  const t = useTranslations();

  return (
    <>
      {features.map(({ id, title, description, image, reverse }) => (
        <FeatureHighlight
          key={id}
          contentElement={
            <>
              <Typography
                variant="h5"
                Element="h5"
                className="mb-4"
                weight="normal"
                color="inherit"
              >
                {t(title)}
              </Typography>
              <Typography color="inherit">{t(description)}</Typography>
            </>
          }
          deviceContent={
            <Image
              src={image}
              format="png"
              width={270}
              height={584}
              alt=""
              loading="lazy"
              className="size-full object-cover object-center"
            />
          }
          reverse={reverse}
        />
      ))}
    </>
  );
};

export default FeatureHighlights;
